var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewResourceService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-471 -276) translate(0 120) translate(472 157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.889,
    cy: 52.889,
    r: 19.111,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M52.444 43.556L52.444 62.222M43.556 53.333L62.222 53.333M27.811 62.222H4.768C2.135 62.222 0 60.08 0 57.436V4.786C0 2.143 2.135 0 4.768 0H38.55c1.264.001 2.476.506 3.37 1.404l9.128 9.161c.894.898 1.396 2.116 1.395 3.386v13.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.556 34.667L11.556 47.111M11.556 44.444h22.222c0-2.209-1.81-4-4.04-4h-5.051c0-2.209-1.81-4-4.04-4h-9.091M32.74 17.2c.264.292.64.459 1.034.459s.77-.167 1.034-.459l.667-.74c.395-.438 1.023-.58 1.568-.354.545.226.888.77.858 1.358l-.05.996c-.022.395.125.78.405 1.06s.666.428 1.062.406l.996-.052c.589-.029 1.132.315 1.357.86.225.544.084 1.17-.353 1.566l-.74.666c-.293.264-.46.64-.46 1.034s.167.77.46 1.034l.74.666c.438.395.58 1.022.354 1.566-.226.544-.77.888-1.358.859l-.996-.051c-.396-.022-.782.126-1.062.405-.28.28-.427.666-.406 1.061l.051.996c.03.588-.313 1.132-.858 1.358-.545.225-1.173.084-1.568-.353l-.667-.741c-.264-.292-.64-.459-1.034-.459-.395 0-.77.167-1.035.459l-.667.74c-.395.438-1.023.58-1.568.354-.544-.226-.888-.77-.858-1.358l.05-.996c.023-.395-.125-.78-.405-1.06s-.666-.428-1.061-.406l-.997.05c-.587.027-1.128-.319-1.351-.863-.223-.543-.08-1.169.356-1.562l.74-.667c.293-.264.46-.64.46-1.033 0-.394-.167-.77-.46-1.034l-.74-.666c-.437-.396-.578-1.023-.352-1.567.225-.544.768-.888 1.357-.86l.996.053c.395.021.781-.126 1.061-.406.28-.28.428-.665.406-1.06l-.05-.996c-.022-.582.322-1.116.86-1.338.539-.222 1.159-.086 1.555.34l.668.735z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.78,
    cy: 24.222,
    r: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewResourceService);
export default __webpack_public_path__ + "static/media/new-resource-service.6cb868d523128f31f383a496c66cb3b2.svg";
export { ForwardRef as ReactComponent };